// extracted by mini-css-extract-plugin
export default {"container":"Sticky_container__Ogtee","slideDown":"Sticky_slideDown__hRgyD","sticky":"Sticky_sticky__m7yV4","slideUp":"Sticky_slideUp__t6ep+"};